import { SingleOption } from '@frontend/basic-forms';
import { EquipmentEnumClient } from '@frontend/equipment/api';
import { EquipmentState, EquipmentStateName } from '@frontend/equipment/types';
import { useEffect, useState } from 'react';

import { EquipmentStateSelectProps } from './equipment-state-select.component';

interface ViewProps {
    options: SingleOption<EquipmentStateName>[];
}

const useEquipmentStateSelect = (props: EquipmentStateSelectProps): ViewProps => {
    const [options, changeOptions] = useState<SingleOption<EquipmentStateName>[]>([]);

    useEffect(() => {
        if (typeof props.subset === 'function') props.subset().then((states) => {
            return changeOptions(
                states
                    .map((state) => {
                        const found = EquipmentState.ALL.find((t) => t.value === state);
                        if (found) {
                            return {
                                value: found.value,
                                label: found.value,
                                display: found.displayName
                            };
                        } else
                            return {
                                value: state,
                                label: state.replace(/_/g, ' ')
                            };
                    })
            );
        });
        else EquipmentEnumClient.fetchEquipmentStates().then((states) => {
            return changeOptions(
                states
                    .filter((state) => (props.subset ? (props.subset as string[]).includes(state) : true))
                    .map((state) => {
                        const found = EquipmentState.ALL.find((t) => t.value === state);
                        if (found) {
                            return {
                                value: found.value,
                                label: found.value,
                                display: found.displayName
                            };
                        } else
                            return {
                                value: state,
                                label: state.replace(/_/g, ' ')
                            };
                    })
            );
        });
    }, [props.subset]);

    return { options };
};

export default useEquipmentStateSelect;
